import { render, staticRenderFns } from "./ModalChooseNumberItem.vue?vue&type=template&id=b2999ee6&scoped=true&"
import script from "./ModalChooseNumberItem.vue?vue&type=script&lang=js&"
export * from "./ModalChooseNumberItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalChooseNumberItem.vue?vue&type=style&index=0&id=b2999ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2999ee6",
  null
  
)

export default component.exports